import type { FormItemProps } from 'antd'
import { Col } from 'antd'
import React from 'react'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'

interface IColFormItemProps extends FormItemProps {
  span?: number
  className?: string
  hide?: boolean
}

const ColFormItem: React.FC<IColFormItemProps> = (props) => {
  const { span = 12, className, children, ...rest } = props
  return rest.hide ? (
    <FormItem {...rest}>{children}</FormItem>
  ) : (
    <Col span={span} className={className}>
      <FormItem {...rest}>{children}</FormItem>
    </Col>
  )
}

ColFormItem.displayName = 'ColFormItem'
export default ColFormItem
